import React from 'react';
import PropTypes from 'prop-types';

const EditSvg = ({ color, width, height }) => {
  return (
    <svg
      width={`${width || 17}`}
      height={`${height || 16}`}
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.34006 2.4L3.86673 8.19333C3.66006 8.41333 3.46006 8.84667 3.42006 9.14667L3.1734 11.3067C3.08673 12.0867 3.64673 12.62 4.42006 12.4867L6.56673 12.12C6.86673 12.0667 7.28673 11.8467 7.4934 11.62L12.9667 5.82667C13.9134 4.82667 14.3401 3.68667 12.8667 2.29334C11.4001 0.913336 10.2867 1.4 9.34006 2.4Z"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.42676 3.36664C8.71342 5.20664 10.2068 6.6133 12.0601 6.79997"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.5 14.6667H14.5"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

EditSvg.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
};

export default EditSvg;
